<mat-form-field [class]="inputClass">
  <mat-label class="with-action">
    <div class="align-h-space-between">
      <span>{{ label }}</span>
      @if (canManage) {
        <button
          appStopPropagation
          type="button"
          class="btn icon icon-plus link"
          (click)="openManageDialog()">
          Add Payer
        </button>
      }
    </div>
  </mat-label>

  <input #searchInput
         matInput
         [errorStateMatcher]="errorStateMatcher"
         [matAutocomplete]="auto"
         [placeholder]="placeholder"
         [(ngModel)]="value"
         type="text"
         (input)="onInput($event.target.value)"
         (blur)="onTouched()">

  <mat-autocomplete #auto="matAutocomplete"
                    (optionSelected)="onSelect($event.option.value)"
                    [displayWith]="displayFn">

    @if (filteredOptions.length) {
      @for (option of filteredOptions; track option) {
        <mat-option [value]="option">
          {{ option[searchBy] }}
        </mat-option>
      }
    }

    @if (!filteredOptions.length) {
      <mat-option [disabled]="true">
        No results found
      </mat-option>
    }
  </mat-autocomplete>

  <div matSuffix>
    <ng-container [appPreloader]="[endpoints.SOLE_CONTACTS_GET]"
                  [preloaderType]="preloaderTypes.ICON"
                  [preloaderSize]="20">
    </ng-container>
  </div>

  <!-- Show control errors -->
  <mat-error>
    <app-validation-error [errors]="ngControl.errors"></app-validation-error>
  </mat-error>
</mat-form-field>
